import { oneDecimalPercentFormatValidateFloatTrue } from 'common/formats/formats';
import { PERCENTILE_RANKING_TITLE } from 'pages/Valuations/approaches/guidelinePublicCompanies/constants';
import {
  PERFORMANCE_METRICS_SPREADSHEET_COLUMN_KEY_PREFIX,
  PERFORMANCE_METRICS_SPREADSHEET_HEADER_CLASSNAME,
  SHEET_ALIASES_CONSTANTS,
  SHEET_TITLES_CONSTANTS,
} from 'pages/Valuations/approaches/guidelinePublicCompanies/PerformanceMetrics/common/constants/performanceMetrics';
import {
  GenerateTransactionConfigsParams,
  PerfMetricsConfigRow,
  RowConfigParams,
} from 'pages/ValuationsAllocation/approaches/TransactionComps/PerformanceMetrics/types';
import { generateColumnKey, getArrayValue, getStringValue } from 'utilities';

const generateTransactionConfigs = (params: GenerateTransactionConfigsParams) => {
  const { transactions } = params;

  return getArrayValue(
    transactions?.map(transaction => ({
      alias: generateColumnKey({
        name: getStringValue(transaction?.target_name),
        prefix: PERFORMANCE_METRICS_SPREADSHEET_COLUMN_KEY_PREFIX,
      }),
      gridType: 'string',
      ignoreRowCopy: true,
      readOnly: true,
      value: getStringValue(transaction?.target_name),
    }))
  ) as PerfMetricsConfigRow[];
};

const rowConfig = (params: RowConfigParams): PerfMetricsConfigRow[] => {
  const { companyName, valuationsApproachGpt } = params;
  const transactions = getArrayValue(valuationsApproachGpt?.gpt_transactions);

  return [
    {
      alias: SHEET_ALIASES_CONSTANTS.PERFORMANCE_METRICS_SPREADSHEET_HEADER_TITLE,
      className: `${PERFORMANCE_METRICS_SPREADSHEET_HEADER_CLASSNAME} division-bottom-only`,
      gridType: 'string',
      ignoreRowCopy: true,
      isParentWithDivider: false,
      readOnly: true,
      value: SHEET_TITLES_CONSTANTS.PERFORMANCE_METRICS_SPREADSHEET_HEADERS[0].value,
      isTitleOrHeader: true,
    } as PerfMetricsConfigRow,
    ...generateTransactionConfigs({ transactions }),
    {
      alias: SHEET_ALIASES_CONSTANTS.PERFORMANCE_METRICS_SPREADSHEET_COMPANY,
      displayBold: true,
      className: 'bolder-row division',
      format: oneDecimalPercentFormatValidateFloatTrue,
      gridType: 'percentage',
      ignoreRowCopy: true,
      readOnly: true,
      value: companyName,
    } as PerfMetricsConfigRow,
    {
      alias: SHEET_ALIASES_CONSTANTS.PERFORMANCE_METRICS_SPREADSHEET_RANK_ALIAS,
      hidden: false,
      gridType: 'percentage',
      format: oneDecimalPercentFormatValidateFloatTrue,
      value: PERCENTILE_RANKING_TITLE,
      forceComponent: true,
      readOnly: true,
      valueViewer: null,
      dataEditor: null,
      isVolatility: null,
      dropdown: false,
      useScalarSpreadsheetCell: false,
      options: null,
    } as PerfMetricsConfigRow,
  ];
};

export default rowConfig;
